import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './pages/Admin/AdminMain';
import MobileAuth from './components/Mobile/MobileAuth';
import MobilePatientDashboard from './components/Mobile/patient/MobilePatientDashboard';
import MobileDoctorDashboard from './components/Mobile/Doctor/MobileDoctorDashboard';
import MobileProviderDashboard from './components/Mobile/Provider/MobileProviderDashboard';

export default function App() {
  const [user, setUser] = useState(null);
  const [page, setPage] = useState('login');
  const [mobilePage, setMobilePage] = useState('auth');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogin = (data) => {
    if (data.goToRegister) { setPage('register'); return; }
    setUser(data);
    if (data.role === 'patient') { setPage('patient'); setMobilePage('patient'); }
    else if (data.role === 'doctor') { setPage('doctor'); setMobilePage('doctor'); }
    else if (data.role === 'provider') { setPage('provider'); setMobilePage('provider'); }
  };

  const handleLogout = () => {
    setUser(null);
    setPage('login');
    setMobilePage('auth');
  };

  // ✅ SUPER ADMIN — always desktop, never mobile
  if (window.location.pathname === '/My-Health-Journal:360-Admin') {
    return <AdminDashboard onLogout={() => { window.location.href = '/'; }} />;
  }

  // ═══════════════════════════════
  // MOBILE VERSION
  // ═══════════════════════════════
  if (isMobile) {
    if (mobilePage === 'auth') return <MobileAuth onLogin={handleLogin} />;
    if (mobilePage === 'patient') return <MobilePatientDashboard user={user} onLogout={handleLogout} />;
    if (mobilePage === 'doctor') return <MobileDoctorDashboard user={user} onLogout={handleLogout} />;
    if (mobilePage === 'provider') return <MobileProviderDashboard user={user} onLogout={handleLogout} />;
  }

  // ═══════════════════════════════
  // DESKTOP VERSION
  // ═══════════════════════════════
  if (page === 'login') return <Login onLogin={handleLogin} />;
  if (page === 'register') return <Register onBack={() => setPage('login')} />;
}